import { render, staticRenderFns } from "./menu-without-roles.vue?vue&type=template&id=b46f8e70&"
import script from "./menu-without-roles.vue?vue&type=script&lang=ts&"
export * from "./menu-without-roles.vue?vue&type=script&lang=ts&"
import style0 from "./menu-without-roles.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports